import React from 'react';
import { cn } from '../../lib/utils';

// Cinta "Agotado" en diagonal sobre la esquina superior izquierda de la foto.
// Debe colocarse dentro de un contenedor con `relative overflow-hidden`.
// El wrapper es un container query (cqw), así grosor y texto escalan con el ancho de la foto.
export const SoldOutRibbon = ({ label = 'Agotado', className }) => (
  <div
    className="absolute inset-0 z-10 pointer-events-none select-none"
    style={{ containerType: 'inline-size' }}
    data-testid="soldout-ribbon"
  >
    <div
      className={cn(
        // Centrada en (20cqw, 20cqw) y girada -45°: cruza el borde superior y el izquierdo;
        // el overflow-hidden del padre recorta los extremos
        'absolute -translate-x-1/2 -translate-y-1/2 -rotate-45',
        'bg-red-600 text-white text-center font-bold uppercase shadow-md',
        className
      )}
      style={{
        top: '20cqw',
        left: '20cqw',
        width: '80cqw',
        fontSize: '6.5cqw',
        lineHeight: 1,
        padding: '2.5cqw 0 2.5cqw 0.15em',
        letterSpacing: '0.15em',
      }}
    >
      {label}
    </div>
  </div>
);

SoldOutRibbon.displayName = 'SoldOutRibbon';
